export const GENERIC_ERROR_MESSAGE = "Oops! We are unable to add items to your cart right now";
export const TRY_AGAIN = "Try Again";

export const QC_ERROR_TITLE_MAX_LINES = 2;

/** Fallback copy */
export const QC_ERROR_FOOTER_FALLBACK = {
    statusTitle: "Our systems are acting up",
    statusMessage: "Whoops! Something went wrong. Please check later",
    ctaText: "Edit Cart",
    ctaAction: "gotocart",
} as const;

/** Analytics context.variant for AIP quick-checkout turbo events */
export const AIP_TURBO_ANALYTICS_VARIANT = "AIP_TURBO";
